import React, { useMemo } from "react";
import { Text, View } from "@components/atoms/Themed";
import Spacer from "@components/atoms/Spacer";
import { StyleSheet } from "react-native";
import Colors from "@constants/Colors";
import Fonts from "@constants/Fonts";
import { ApplyPrice } from "@constants/App";
import numberFormat from "@lib/util/numberFormat";
import { calculateInfluencerReward } from "@lib/util/influencerReward";

type Props = {
  customPrice: number;
  price: number;
  status: string;
  prType: string;
};

export default function DetailUnitPriceLabel({
  customPrice,
  price,
  status,
  prType,
}: Props): JSX.Element {
  const statusText = useMemo(() => {
    if (["applied", "office_approved", "admin_approved"].includes(status)) {
      return "応募中";
    }
    if (status === "agency_approved") {
      return "採択されました";
    }
    return "";
  }, [status]);

  const detailUnitPrice = useMemo(
    () => (status === "agency_approved" ? price : customPrice),
    [customPrice, price, status]
  );

  // 報酬額を計算
  const influencerReward = useMemo(
    () => calculateInfluencerReward(detailUnitPrice),
    [detailUnitPrice]
  );

  return (
    <View style={styles.container}>
      <View style={styles.box}>
        <Text style={styles.status}>{statusText}</Text>
      </View>
      {["rewarded"].includes(prType) && (
        <View style={styles.priceContainer}>
          {/* 希望報酬（広告主支払額）を表示 */}
          <View style={styles.price}>
            <Text style={styles.label}>{ApplyPrice}</Text>
            <Spacer width={8} />
            <Text style={styles.unitPrice}>
              {numberFormat(detailUnitPrice, "¥")}
            </Text>
          </View>
          {/* 報酬額（インフルエンサー受取額）を表示 */}
          <View style={styles.price}>
            <Text style={styles.label}>報酬額</Text>
            <Spacer width={8} />
            <Text style={styles.unitPrice}>
              {numberFormat(influencerReward, "¥")}
            </Text>
          </View>
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.85)",
    height: 52,
    paddingHorizontal: 16,
    justifyContent: "space-between",
  },
  box: {
    flex: 1,
    backgroundColor: "transparent",
  },
  priceContainer: {
    backgroundColor: "transparent",
    flexDirection: "column",
    alignItems: "flex-end",
  },
  price: {
    backgroundColor: "transparent",
    flexDirection: "row",
    alignItems: "center",
  },
  status: {
    color: Colors.white,
    ...Fonts.xlb100,
  },
  label: {
    color: Colors.white,
    ...Fonts.sr100,
  },
  unitPrice: {
    color: Colors.white,
    ...Fonts.ensb100,
  },
});
